// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

export const AmenityCategoryTypeValues = new Set([
  'UNSET' as const,
  'EAT' as const,
  'SHOP' as const,
]);
export type AmenityCategoryType = typeof AmenityCategoryTypeValues extends Set<infer U> ? U : never;

